<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <!-- <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                云掌舵功能介绍
            </div>
        </div> -->
        <!-- 盒子 -->
        <!-- <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <div class="border" style="display: flex;">
                        <div style="">
                            <img src="../assets/page1.png" alt="">
                        </div>
                        <div>
                            <span>工作流</span>
                            <span>流程化协同办公</span>
                            <span></span>
                        </div>
                    </div>
                </el-col>
             
            </el-row>
        </div> -->
        <!-- 手机端商品展示 -->
        <div id="功能介绍" class="head-label">
            <div style="text-align: center;" class="font_size_24">
                云掌舵功能介绍
            </div>
        </div>




        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page13.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">品牌分析</div>
                            <!-- <div class="product_font_style product_mobile_content_one" >帮助亚马逊注册的品牌更好地了解其客户、商品和亚马逊商店的整体绩效。</div> -->
                            <div class="product_font_style product_mobile_content_one" >访问包含有关亚马逊卖家和供应商绩效信息的报告以及消费者行为报告，这些报告可深入了解客户如何在亚马逊上查找和购买销售合作伙伴的产品</div>
                            <div class="product_font_style product_mobile_content_one" >流量分析：根据亚马逊卖家店铺的流量报告和实时流量报告，提供卖家一站式信息显示及分析</div>
                            <div class="product_font_style product_mobile_content_one" >全系商品搜索表现：显示客户在整个搜索购物过程中如何与您的品牌商品互动，旨在帮助您更好地了解自己的销售渠道；</div>
                            <div class="product_font_style product_mobile_content_one" >搜索词表现：列出引导客户访问您的品牌商品的热门查询；</div>
                            <div class="product_font_style product_mobile_content_one" >重复购买行为：按品牌或 ASIN 分析买家保留率和重复购买模式；</div>
                            <div class="product_font_style product_mobile_content_one" >人口统计数据：通过客户人口统计数据分析，更有效地与目标受众建立联系或发现定制商机；</div>
                            <div class="product_font_style product_mobile_content_one" >热门搜索词：提供按搜索频率排序的特定时间范围内热门搜索词的可见性；</div>
                            <div class="product_font_style product_mobile_content_one" >购物篮分析：洞察最经常同时购买的商品，根据买家的购买模式发掘有效捆绑和交叉销售的机会。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>







        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page1.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">工作流</div>
                            <div class="product_font_style product_mobile_content_one" >协同化流程办公</div>
                            <div class="product_font_style product_mobile_content_one" >供应商及企业各部门共同参与工作流，协作更便利。</div>
                            <div class="product_font_style product_mobile_content_one" >待办事项与钉钉结合，提高办公效力与管理水平。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>


        <!-- <div id="统计报表" class="head-label">
            <div style="text-align: center;" class="font_size_24">
                统计报表
            </div>
        </div> -->
        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">统计报表</div>
                            <div class="product_font_style product_mobile_content_one" >多维度可配置的报表分析，图表结合，指标监测</div>
                            <div class="product_font_style product_mobile_content_one" >多维度销售报表：销售日报、月报、地区销售分布、新老客户销售、爆款销售排名和退货情况等分析，全面掌握店铺运营状况。</div>
                            <div class="product_font_style product_mobile_content_one" >销售支持报表：强大的ERP内核支持，统计分析采购、交期、品质、库存、物流及报关等情况，实时把握供应链，更好服务前端销售。</div>
                            <div class="product_font_style product_mobile_content_one" >财务报表：通过采购、库存和销售动态分析，优化运营环节，提高资金周转率；精确统计商品、运营团队利润情况，调整产品策略和团队管理。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page2.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>



        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page3.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">供应商管理</div>
                            <div class="product_font_style product_mobile_content_one" >供应链管理可细化到生产前端，实现供应商代发货</div>
                            <div class="product_font_style product_mobile_content_one" >系统化匹配协同办公，供应商可以登录系统，完成相关流程的确认。</div>
                            <div class="product_font_style product_mobile_content_one" >统化管理订单生产进度、交期、品质等信息，供应商可以代发货，实现零库存管理。</div>
                            <div class="product_font_style product_mobile_content_one" >通过供应商交期排名等统计报表，综合考核供应商竞争力。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">品质管理</div>
                            <div class="product_font_style product_mobile_content_one" >规范化品质检验，数据可溯源监控，确保产品批次稳定性</div>
                            <div class="product_font_style product_mobile_content_one" >系统化配置质量检验标准、方案等，可在生产、交货过程检验每一批次订单品质。</div>
                            <div class="product_font_style product_mobile_content_one" >通过供应商产品在厂品质检验，可实现供应商代发货流程。</div>
                            <div class="product_font_style product_mobile_content_one" >通过供应商品质排名等统计报表，综合考核供应商竞争力。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page4.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page5.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">采购管理</div>
                            <div class="product_font_style product_mobile_content_one" >结合销售计划、智能补货建议、库存及订单情况，严谨、高效地制定采购计划。</div>
                            <div class="product_font_style product_mobile_content_one" >完整的采购合同、变更、退货等流程，解决采购的任何需求。</div>
                            <div class="product_font_style product_mobile_content_one" >统化管理订单生产进度、交期、品质等信息，供应商可以代发货，实现零库存管理。</div>
                            <div class="product_font_style product_mobile_content_one" >通过采购计划、订单执行情况等统计分析，及时服务前端销售。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">仓储物流管理</div>
                            <div class="product_font_style product_mobile_content_one" >准确掌握即时库存、调拨、出入库和物流等状况，多维度库存指标透视</div>
                            <div class="product_font_style product_mobile_content_one" >系统化管理供应商、本地仓和FBA仓，实时掌握库存变化。</div>
                            <div class="product_font_style product_mobile_content_one" >通过管理物流供应商的协作，不断优化物流成本和送货效率。</div>
                            <div class="product_font_style product_mobile_content_one" >系统数据化管理商品从采购到质检、入库、调拨等环节，通过库存账等报表分析，可持续优化供应链效率。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page6.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page7.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">财务管理</div>
                            <div class="product_font_style product_mobile_content_one" >实现供应商智能对账，进销存各环节财务指标监控</div>
                            <div class="product_font_style product_mobile_content_one" >智能对账：商品采购入库的同时自动生成应付单，结合供应商账期条件，自动对账。</div>
                            <div class="product_font_style product_mobile_content_one" >通过应收、应付账龄分析，进一步优化采购、库存管理，提高资金利用率。</div>
                            <div class="product_font_style product_mobile_content_one" >通过多维度产品利润分析（按品类、销售组、新老客户等），优化运营策略。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">FBA智能对接</div>
                            <div class="product_font_style product_mobile_content_one" >完美对接亚马逊平台数据，实现商品信息管理、订单直接管理，智能补货建议</div>
                            <div class="product_font_style product_mobile_content_one" >在线商品管理：告别亚马逊后台，ERP全自动与亚马逊FBA库存数据API接口对接，直接商品进行上下架、删除等操作；</div>
                            <div class="product_font_style product_mobile_content_one" >订单管理：完美展示统计FBA商品销量、退货率、库存等数据，实时掌握商品状态。</div>
                            <div class="product_font_style product_mobile_content_one" >智能补货：只需设置好备货天数和FBA发货天数，系统会自动帮你计算可售天数和需要开始备货的产品数量。</div>
                            <div class="product_font_style product_mobile_content_one" >商品管理：通过ERP对接的亚马逊商品信息接口，对亚马逊商品进行创建和管理，包括A+商品描述</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page8.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>



        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page9.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">CRM客服管理</div>
                            <div class="product_font_style product_mobile_content_one" >邮件智能化客户分组营销，中差评监控、卖家反馈和评论、流程化处理等，快速响应客户问答</div>
                            <div class="product_font_style product_mobile_content_one" >邮箱管理：亚马逊各站点邮箱配置，可选择指定邮箱操作不同类型邮件，清晰管理。</div>
                            <div class="product_font_style product_mobile_content_one" >客户分组：对所有下单的买家进行统一管理，通过自定义方式，精准筛选分类不同类型买家；对不同回购数和客单价用户，进行一键分组，差异化邮件营销，提升回购率。</div>
                            <div class="product_font_style product_mobile_content_one" >买家问答统计：实时采集亚马逊买家提问，客服可以快速与客户互动，促进成交。</div>
                            <div class="product_font_style product_mobile_content_one" >邮件智能营销：对下单用户进行智能的下单关怀、日常关怀等主动营销，维护客户关系，也可以手动进行批量的分组营销或者新品推广等。</div>
                            <div class="product_font_style product_mobile_content_one" >邮件智能化客户分组营销，中差评监控、卖家反馈和评论、流程化处理等，快速响应客户问答</div>
                            <div class="product_font_style product_mobile_content_one" >中差评监控及售后处理：实时监控店铺的Feedback中差评和Reviews中差评，内部流程化处理跟踪。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>



        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">CPC广告管理</div>
                            <div class="product_font_style product_mobile_content_one" >一站式广告创建管理，灵活设置广告方案，指标异常预警</div>
                            <div class="product_font_style product_mobile_content_one" >授权CPC：完美替代亚马逊的CPC管理后台；多人员、多店铺同时管理，实现防关联；</div>
                            <div class="product_font_style product_mobile_content_one" >广告创建管理：一站式新建广告、广告组和关键词等，与亚马逊后台同步，可实时暂停、开启或调整广告出价；</div>
                            <div class="product_font_style product_mobile_content_one" >分时调价和质量分：针对不同产品，不同时段设置不同的出价策略；实时统计分析广告质量，分数显示。</div>
                            <div class="product_font_style product_mobile_content_one" >广告异常诊断：实时数据监控，若重要指标涨幅和降幅超过一定值，系统及时发出预警提醒，方便快速调整广告策略。</div>
                            <div class="product_font_style product_mobile_content_one" >一键否词：可对任意时间的自动广告组关键词进行管理，进行一键否词；可否定到广告活动或广告组。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page10.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24">
                            <img src="../assets/page11.png" style="width: 100%;">
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;">
                            <div class="product_mobile_title font_size_30">独立站管理</div>
                            <div class="product_font_style product_mobile_content_one" >无缝对接独立站销售数据，智能化共享FBA</div>
                            <div class="product_font_style product_mobile_content_one" >销售订单管理：实时同步独立站销售订单，实现FBA仓自动发货，店铺运营更便利。</div>
                            <div class="product_font_style product_mobile_content_one" >智能化共享FBA：独立站可实时同步FBA库存、物流、售后数据，免除独立站人工操作，统一管理。</div>
                            <div class="product_font_style product_mobile_content_one" >销售统计分析：通过销售统计、地区销售分布、新老客户销售、爆款销售排名等分析，全面掌握店铺运营状况。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" >邮件智能营销：对下单用户进行智能的下单关怀、日常关怀等主动营销，维护客户关系，也可以手动进行批量的分组营销或者新品推广等。</div>
                            <div class="product_font_style product_mobile_content_one" >邮件智能化客户分组营销，中差评监控、卖家反馈和评论、流程化处理等，快速响应客户问答</div>
                            <div class="product_font_style product_mobile_content_one" >中差评监控及售后处理：实时监控店铺的Feedback中差评和Reviews中差评，内部流程化处理跟踪。</div> -->
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>
                
            </el-row>
        </div>


        <div class="product_mobile">
            <el-row>

                <el-col :xs="24" :sm="12">
                    <div class="product_mobile_content" style="padding-top: 50%;position: relative;">
                        <div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;
                        justify-content: center;align-items: center;flex-direction: column;padding: 0 50px;">
                            <div class="product_mobile_title font_size_30">运营参谋</div>
                            <div class="product_font_style product_mobile_content_one" >关键词分析、竞品跟踪、亚马逊索赔，以及跟卖等运营工具持续升级更新。</div>
                            <div class="product_font_style product_mobile_content_one" >关键词分析：多站点精准类目关键词调研；获取亚马逊推荐的长尾关键词，无限制获取海量长尾关键词，更可分组保存。</div>
                            <div class="product_font_style product_mobile_content_one" >竞品跟踪：通过采集亚马逊商品的相关数据，如价格、排名、销量、评价等信息采集和统计分析，用于新品调研、产品改进及推广策略制定。</div>
                            <div class="product_font_style product_mobile_content_one" >亚马逊索赔：亚马逊系统庞大，有一定出错比例，比如商品丢失损坏后漏退款、货物打包尺寸有误、推荐费差错等。通过数据跟踪比对，申诉拿回店家的索赔款。</div>
                            <!-- <div class="product_font_style product_mobile_content_one" >广告异常诊断：实时数据监控，若重要指标涨幅和降幅超过一定值，系统及时发出预警提醒，方便快速调整广告策略。</div>
                            <div class="product_font_style product_mobile_content_one" >一键否词：可对任意时间的自动广告组关键词进行管理，进行一键否词；可否定到广告活动或广告组。</div> -->
                            <!-- <div class="product_font_style product_mobile_content_one" v-for="(content, index) in products[0].content" :key="index">{{content}}</div> -->
                        </div>
                    </div>
                </el-col>


                <el-col :xs="24" :sm="12">
                    <el-row :gutter="20">
                        <el-col span="24" style="text-align: center;">
                            <img src="../assets/page12.png" style="width: 500px;">
                        </el-col>
                    </el-row>
                </el-col>

                
                
            </el-row>
        </div>


        



        <!-- 后台管理 -->
        <!-- <div class="product_pc">
            <el-row>
                <el-col :xs="24" :sm="12">
                    <div class="product_pc_one">
                        <div class="product_mobile_title font_size_30">{{manages[0].title}}</div>
                        <div style="margin-top: 20px" class="product_font_style">{{manages[0].content[0]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[1]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[2]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[3]}}</div>
                        <div style="margin-top: 10px" class="product_font_style">{{manages[0].content[4]}}</div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <img :src="manages[0].img[0]" class="product_pc_img"/>
                </el-col>
            </el-row>
        </div> -->
        <!-- 产品特点-->
        <!-- <div id="产品特点" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                产品特点
            </div>
        </div>
        <div class="product_spec_parent">
            <div class="border_one border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[0].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[0].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[0].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[0].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img"/>
            </div>
            <div class="border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[1].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[1].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[1].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[1].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img"/>
            </div>
            <div class="border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[2].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[2].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[2].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[2].contents[1]}}
                    </div>
                </div>
            </div>
            <div>
                <img :src="computeArrowImg" class="border_spec_img"/>
            </div>
            <div class="border_spec" style="margin-right: 0">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[3].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
                        {{spec.product[3].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[3].contents[0]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[3].contents[1]}}
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 合作伙伴-->
        <!-- <div id="合作伙伴" class="cooperation head-label">
            <div style="text-align: center;" class="font_size_24">
                合作伙伴
            </div>
        </div>
        <div class="cooperation_parent">
            <div style="width: auto; height: auto; margin: auto">
                <img style="height: 160px;width: 160px;" src="../../static/other/partner_01.jpg"/>
                <img style="height: 160px;width: 160px;margin-left: 30px;" src="../../static/other/partner_02.jpg"/>
            </div>
        </div> -->



        <div id="系统优势" class="about_me head-label">
            <div style="text-align: center;font-weight: bold;" class="font_size_24">
                系统优势
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <!-- <p style="font-size: 36px;text-align: center;margin-top: 80px;">联系我们 · <span style="color: #FB8C00">获得高效管理方案</span></p> -->
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 80px;">
                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/更智能.png" >
                        <span style="font-weight: bold;">更智能</span>
                        <span >系统化监控各个环节状态，准确了解运营状态。</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/更轻松.png" alt="">
                        <span style="font-weight: bold;">更轻松</span>
                        <span>复杂的工作流程自动化，内部管理得心应手。</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/更便捷.png" alt="">
                        <span style="font-weight: bold;">更便捷</span>
                        <span>云端部署，同步平台数据，随时随地访问系统。</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/更可靠.png" alt="">
                        <span style="font-weight: bold;">更可靠</span>
                        <span>SAAS平台模式，数据安全，系统更稳定。</span>
                    </div>
                </div>
                <!-- <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p> -->
            </div>
        </div>



        <div id="定制方案" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                云掌舵为您实现
            </div>
        </div>
        <div style="width: 90%;background-color: white;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 26px;text-align: center;margin-top: 80px;">亿级卖家企业规范化管理</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 10px;">
                    <img src="../assets/page15.jpg" alt="">
                </div>
            </div>
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 26px;text-align: center;margin-top: 80px;">供应链深度整合</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 10px;">
                    <img src="../assets/page16.jpg" alt="">
                </div>
            </div>
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 26px;text-align: center;margin-top: 80px;">卖家老板的运营报表</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 10px;">
                    <img src="../assets/page17.jpg" alt="">
                </div>
            </div>
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 26px;text-align: center;margin-top: 80px;">运营数据智能化、预警管理</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 10px;">
                    <img src="../assets/page18.jpg" alt="">
                </div>
            </div>
        </div>



        <div id="系统优势" class="about_me head-label">
            <div style="text-align: center;font-weight: bold;" class="font_size_24">
                云掌舵为您提供
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 36px;text-align: center;margin-top: 80px;">专属的信息化管理系统定制</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 80px;">
                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/图片15.png" >
                        <span style="font-weight: bold;">深度定制您的需求</span>
                        <span >根据行业特性，个性化功能开发</span>
                        <span>您满意的工作流</span>
                        <span>报表定制</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/图片16.png" alt="">
                        <span style="font-weight: bold;">专业的实施服务</span>
                        <span>十年ERP实施顾问服务</span>
                        <span>系统化快速上手，降低学习成本</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/图片17.png" alt="">
                        <span style="font-weight: bold;">增值服务</span>
                        <span>运营工具更新升级</span>
                        <span>大数据分析</span>
                    </div>

                    <div class="about-item">
                        <img style="width: 200px;height: 100px;" src="../assets/图片18.png" alt="">
                        <span style="font-weight: bold;">商学院联盟</span>
                        <span>大卖家运营经验交流</span>
                        <span>品牌建设</span>
                        <span>异业联盟</span>
                    </div>
                </div>
                <!-- <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p> -->
            </div>
        </div>




        <div id="介绍" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                英智云介绍
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 16px;text-align: center;margin-top: 80px;padding: 0 200px;">厦门英智云科技有限公司成立于2016年08月04日，坐落于厦门火炬高新区软件园三期溪西山尾路39号302-3单元，是厦门市高新技术企业、国家高新技术企业。公司汇聚了曾供职于电商运营、大型ERP实施等领域的专业技术人才，现有员工三十多人。</p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 80px;">
                    <div class="about-item">
                        <p>双高企业</p>
                        <span >国家高新技术企业</span>
                        <span >厦门市高新技术企业</span>
                    </div>

                    <div class="about-item">
                        <p>ERP经验</p>
                        <span >30+员工数量</span>
                        <span>电商运营+ERP实施+专业技术人员组合开发</span>
                    </div>

                    <div class="about-item">
                        <p>专业服务</p>
                        <span >快速响应</span>
                        <span>7*10在线服务</span>
                    </div>
                </div>
                <!-- <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p> -->
            </div>
        </div>



        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;font-family: 'Microsoft YaHei';">
                <p style="font-size: 36px;text-align: center;margin-top: 80px;">联系我们 · <span style="color: #FB8C00">获得高效管理方案</span></p>
                <div style="font-size: 16px;display: flex;justify-content: center;margin: 80px;">
                    <div class="about-item">
                        <img src="../assets/phone.png" >
                        <span >电话：18159884932</span>
                    </div>

                    <div class="about-item">
                        <img src="../assets/qq.png" alt="">
                        <span >QQ：1975191566</span>
                    </div>

                    <div class="about-item">
                        <img src="../assets/email.png" alt="">
                        <span >邮箱：chenx@biamazon.com</span>
                    </div>

                    <div class="about-item">
                        <img src="../assets/address.png" alt="">
                        <span >地址：厦门市软件园三期诚毅北大街5号23层2301单元</span>
                    </div>
                </div>
                <!-- <p class="about_me_p">{{company[0]}}</p>
                <p class="about_me_p">{{company[1]}}</p>
                <p class="about_me_p">{{company[2]}}</p>
                <p class="about_me_p">{{company[3]}}</p> -->
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                images: [
                    {
                        img: require('../../static/other/用户管理.png'),
                        title: "用户管理",
                        content: ["用户消费分析", "用户标签设定"]
                    },
                    {
                        img: require('../../static/other/店铺管理.png'),
                        title: "店铺管理",
                        content: ["店铺模板切换", "店铺商品上架"]
                    },
                    {
                        img: require('../../static/other/数据分析.png'),
                        title: "数据分析",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }, {
                        img: require('../../static/other/用户构建.png'),
                        title: "用户互动",
                        content: ["营销活动通知", "用户粘连度提升"]
                    },
                    {
                        img: require('../../static/other/品牌渠道.png'),
                        title: "品牌渠道",
                        content: ["打造店铺自主品牌", "品牌多样化管理"]
                    }
                ],
                products: [
                    {
                        img: [
                            {
                                left: require('../../static/other/1.jpg'), 
                                right: require('../../static/other/2.jpg'), 
                            },
                            {
                                left: require('../../static/other/3.jpg'), 
                                right: require('../../static/other/4.jpg'), 
                            },
                            {
                                left: require('../../static/other/5.jpg'), 
                                right: require('../../static/other/6.jpg'), 
                            }
                        ],
                        title: "手机端商品展示，强大的商品规格设计",
                        content: [
                            "商品热销分类显，分类导航显示所有分类", 
                            "热销商品优先排序 商城首页轮播自定义",
                            "单品、多规格、加料、属性、多价格展示",
                            "商品分类列表支持虚拟列表，滚动众享丝滑",
                            "无需注册会员，商品在线购买支付"
                        ]
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/product_info.jpg')],
                        title: "小程序+公众号一体化微信商城管理平台",
                        content: ["公众号菜单自定义发布 微信图文图片素材管理", "商品多规格SKU自定义上架 分类自定义设置",
                            "用户管理 用户自定义标签，了解用户消费行为",
                            "订单管理 实时掌握商品交易详情", "物流闪电发货 实时掌握物流追踪状态",
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "一键建铺",
                            contents: ["注册一键创建店铺", "开启您的专属店铺"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "店铺装扮",
                            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"]
                        },
                        {
                            img: require('../../static/other/数据分析.png'),
                            title: "营销分析",
                            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "助力零售",
                            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"]
                        }
                    ]
                },
                company: [
                    "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                    "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                    "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                    "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/a5.jpg")
                },
                // {
                //     img: require("../../static/slider/a2.jpg")
                // },
                // {
                //     img: require('../../static/slider/a3.jpg')
                // },
                // {
                //     img: require('../../static/slider/a4.jpg')
                // }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
        padding: 10px 0;
    }

    .slider_img {
        height: 550px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        padding: 20px 0;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        /* height: 300px; */
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
        padding: 20px auto;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 2em;
    }



    .about-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 20px;
        width: 250px;
        text-align: center;
    }
</style>